import {
    WorkspaceView,
    WorkspaceColumn,
} from "@common/types/views/workspaceViews";
import { ViewType } from "@common/types/views/views";

export const DefaultWorkspaceView: WorkspaceView = {
    type: ViewType.WORKSPACE,
    options: {
        selection: true,
        bulkActions: false,
    },
    columns: [
        { id: WorkspaceColumn.NAME },
        { id: WorkspaceColumn.ENTITIES },
        { id: WorkspaceColumn.TEAM },
    ],
    filters: {},
};
